<template>
  <card>
    <list v-if="$store.state.user.is_root" :columns="columns" :modalCreate="modalCreate" :removeLink="removeLink"
      :cardLink="cardLink" :isUpdate="true" :isAdd="true" :itemLink="itemLink" :setLink="setLink" :openItem="true"
      :fields="fields" :searchDisable="true" @change="change" @changeFunction="changeFunction" v-model="val" />
  </card>
</template>
<script>
export default {
  name: "products",
  methods: {
    changeFunction(val) { },
    change(val) { },
  },
  data() {
    return {
      val: [],
      modalCreate: "payment",
      fields: [
        {
          key: "title",
          label: "Название",
          isMultiLang: true,
          type: 'field',
        },
        {
          key: "description",
          label: "Краткое описание",
          isMultiLang: true,
          type: 'textarea',
        },
        {
          key: "price_fix",
          label: "Стоимость за 1 транзакцию",
          type: "field",
          textType: "number",
        },
        {
          key: "price_percent",
          label: "Процест транзакции",
          type: "field",
          textType: "number",
        },
        {
          key: "is_active",
          label: "Период (месяцев)",
          type: "checkbox",
      
        },
        {
          key: "is_online",
          label: "Онлайн оплата",
          type: "checkbox",

        },
      ],
      /** APIs */
      removeLink: "",
      cardLink: "item_payment",
      itemLink: "payments",
      setLink: "payments",
      columns: [
        {
          key: "title",
          title: "Название",
        },
        {
          key: "is_active",
          title: "Активность",
        },
        {
          key: "is_online",
          title: "Оплата онлайн",
        },
  
        {
          detail: true,
        },
      ],
    };
  },
};
</script>
<style>

</style>
